import {isValid} from 'date-fns';
import {parseDate} from 'presentation/utils';
import {translations} from 'presentation/translations-new';

const {invalidDate, invalidFutureDate} = translations['pt-br'].privateFlow.consultRefund;

export interface DateValidationResult {
	isValid: boolean;
	message?: string;
}

export const validateDateFormat = (value: string | undefined): DateValidationResult => {
	if (!value || value.trim() === '') {
		return {isValid: true};
	}

	const parsedDate = parseDate(value);
	if (!isValid(parsedDate)) {
		return {isValid: false, message: invalidDate};
	}

	return {isValid: true};
};

export const validateNotFutureDate = (value: string | undefined): DateValidationResult => {
	if (!value || value.trim() === '') {
		return {isValid: true};
	}

	const parsedDate = parseDate(value);
	const dateNow = new Date();

	if (parsedDate && parsedDate >= dateNow) {
		return {isValid: false, message: invalidFutureDate};
	}

	return {isValid: true};
};

export const validateMinDate = (value: string | undefined): DateValidationResult => {
	if (!value || value.trim() === '') {
		return {isValid: true};
	}

	const parsedDate = parseDate(value);
	const minDate = new Date('2000');

	if (parsedDate && parsedDate <= minDate) {
		return {isValid: false, message: invalidDate};
	}

	return {isValid: true};
};

export const validateServiceDate = (value: string | undefined): DateValidationResult => {
	const formatValidation = validateDateFormat(value);
	if (!formatValidation.isValid) {
		return formatValidation;
	}

	const futureValidation = validateNotFutureDate(value);
	if (!futureValidation.isValid) {
		return futureValidation;
	}

	const minDateValidation = validateMinDate(value);
	if (!minDateValidation.isValid) {
		return minDateValidation;
	}

	return {isValid: true};
};

export const zodDateValidators = {
	isValidFormat: (value: string | undefined) => {
		if (!value || value.trim() === '') return true;
		const parsedDate = parseDate(value);
		return isValid(parsedDate);
	},

	isNotFutureDate: (value: string | undefined) => {
		if (!value || value.trim() === '') return true;
		const parsedDate = parseDate(value);
		const dateNow = new Date();
		return parsedDate && parsedDate < dateNow;
	},

	isAfterMinDate: (value: string | undefined) => {
		if (!value || value.trim() === '') return true;
		const parsedDate = parseDate(value);
		const minDate = new Date('2000');
		return parsedDate && parsedDate > minDate;
	},
};
